export default __webpack_public_path__ + "static/media/mealoftheday.3140a8f6.jpg";